import { CLOUD_STATUS } from '@/views/settings/settingsCloud/cloud.const';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { Cloud_UrlDocument } from '@/graphql/codegen/generated/graphql';

const getCloudRedirectUrl = (redirectPath: string) =>
  process.env.NODE_ENV === 'production'
    ? `${window.location.origin}/${redirectPath}`
    : `${process.env.VUE_APP_IB_MANAGER_PROTOCOL}//${process.env.VUE_APP_IB_MANAGER_HOSTNAME}:${process.env.VUE_APP_IB_MANAGER_PORT}/${redirectPath}`;

export const openCloudRedirectUrl = async (selectedCoordinator: string, cloudStatus: CLOUD_STATUS) => {
  const cloudUrlGql = await apolloClient.query({
    query: Cloud_UrlDocument,
    variables: {
      coordinatorId: selectedCoordinator || '',
    },
    fetchPolicy: 'no-cache',
  });
  const { cloudUrl, token, redirectPath } = cloudUrlGql.data.cloud_url || {};
  const redirect_uri = getCloudRedirectUrl(redirectPath);
  const actionUpdateParam = [CLOUD_STATUS.Paused, CLOUD_STATUS.Enabled].includes(cloudStatus) ? '&action=update' : '';
  const win = window.open(`${cloudUrl}${actionUpdateParam}&jwt=${token}&redirect_uri=${redirect_uri}`, '_blank');
  win?.focus();
};
